module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bc-spec-detail"
  }, [(_vm.goods.id) ? _c('div', {
    staticClass: "bc-spec-detail__inner"
  }, [_c('a', {
    staticClass: "bc-spec-detail__back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goMall($event)
      }
    }
  }, [_vm._v("\n      ← " + _vm._s(_vm.$T('观众中心返回商城')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "bc-spec-detail__main"
  }, [_c('div', {
    staticClass: "bc-spec-detail__gallery"
  }, [_c('img', {
    staticClass: "bc-spec-detail__pic",
    attrs: {
      "src": _vm.currentPic,
      "alt": _vm.goodsTitle
    }
  }), _vm._v(" "), (_vm.pics.length > 1) ? _c('div', {
    staticClass: "bc-spec-detail__thumbs"
  }, _vm._l((_vm.pics), function(pic, idx) {
    return _c('button', {
      key: idx,
      staticClass: "bc-spec-detail__thumb",
      class: {
        'is-active': pic === _vm.currentPic
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.currentPic = pic
        }
      }
    }, [_c('img', {
      attrs: {
        "src": pic,
        "alt": ""
      }
    })])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bc-spec-detail__info"
  }, [_c('h1', {
    staticClass: "bc-spec-detail__title"
  }, [_vm._v(_vm._s(_vm.goodsTitle))]), _vm._v(" "), (_vm.goodsDesc) ? _c('p', {
    staticClass: "bc-spec-detail__desc"
  }, [_vm._v(_vm._s(_vm.goodsDesc))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "bc-spec-detail__price"
  }, [_vm._v(_vm._s(_vm.money(_vm.displayPrice)))]), _vm._v(" "), _vm._l((_vm.skuTree), function(tree) {
    return _c('div', {
      key: tree.k_s,
      staticClass: "bc-spec-detail__sku-group"
    }, [_c('div', {
      staticClass: "bc-spec-detail__sku-label"
    }, [_vm._v(_vm._s(_vm.skuFieldLabel(tree)))]), _vm._v(" "), _c('div', {
      staticClass: "bc-spec-detail__sku-opts"
    }, _vm._l((tree.v), function(attr) {
      return _c('button', {
        key: attr.id,
        staticClass: "bc-spec-detail__sku-opt",
        class: {
          'is-active': _vm.selected[tree.k_s] == attr.id
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.selectAttr(tree.k_s, attr)
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm.skuAttrLabel(attr)) + "\n            ")])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "bc-spec-detail__qty"
  }, [_c('span', {
    staticClass: "bc-spec-detail__sku-label"
  }, [_vm._v(_vm._s(_vm.$T('观众中心数量')))]), _vm._v(" "), _c('div', {
    staticClass: "bc-spec-detail__qty-ctrl"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCount(-1)
      }
    }
  }, [_vm._v("−")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.count),
      expression: "count",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.count)
    },
    on: {
      "change": _vm.normalizeCount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.count = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCount(1)
      }
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('button', {
    staticClass: "bc-spec-detail__buy",
    attrs: {
      "type": "button",
      "disabled": _vm.buying
    },
    on: {
      "click": _vm.buyNow
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$T('观众中心立即购买')) + "\n        ")])], 2)]), _vm._v(" "), (_vm.goodsContent) ? _c('div', {
    staticClass: "bc-spec-detail__content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$T('观众中心商品详情')))]), _vm._v(" "), _c('div', {
    staticClass: "bc-spec-detail__html",
    domProps: {
      "innerHTML": _vm._s(_vm.goodsContent)
    }
  })]) : _vm._e()]) : _c('div', {
    staticClass: "bc-spec-detail__empty"
  }, [_vm._v(_vm._s(_vm.$T('观众中心加载中')))]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2829be12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/SpectatorGoodsDetail.vue
// module id = 1386
// module chunks = 0